import { AccountsService } from 'base/accounts_service';
import { Button } from 'base/ui/button';
import { RedErrorText } from 'base/ui/form';
import { Rows } from 'base/ui/layout';
import React from 'react';

import { AccountStore } from 'base/account_store';
import { posthogIdentify } from 'base/posthog';
import { getReferralCode } from 'base/referral';
import { NONCE_KEY, STATE_KEY } from 'blocks/auth/google_sign_in_gsi';
import { saveUserJwt } from '../../../library/src/modules/cookies';
import IconRelumeColorLarge from '../relume_color_large.react.svg';
import styles from './google_callback.css';
export function GoogleCallback({
  accountsService,
  accountStore,
  onLogin,
  onSignup,
}: {
  accountsService: AccountsService;
  accountStore: AccountStore;
  onLogin: () => void;
  onSignup: () => void;
}) {
  const [error, setError] = React.useState<string | null>(null);
  const [isProcessing, setIsProcessing] = React.useState(true);
  const defaultErrorMessage = 'Failed to complete authentication';
  React.useEffect(() => {
    const handleCallback = async () => {
      try {
        const hash = window.location.hash.substring(1); // Remove the '#' character
        const params = new URLSearchParams(hash);
        const idToken = params.get('id_token');
        const state = params.get('state');
        if (!idToken) {
          setError(defaultErrorMessage);
          setIsProcessing(false);
          return;
        }

        //Validate parameters
        const savedState = sessionStorage.getItem(STATE_KEY);
        if (!state || !savedState) {
          setError(defaultErrorMessage);
          setIsProcessing(false);
          return;
        }
        sessionStorage.removeItem(STATE_KEY);
        const nonce = sessionStorage.getItem(NONCE_KEY);
        if (!nonce) {
          setError(defaultErrorMessage);
          setIsProcessing(false);
          return;
        }
        sessionStorage.removeItem(NONCE_KEY);
        const referralCode = getReferralCode();
        const response =
          await accountsService.exchangeGoogleAccessTokenForToken({
            accessToken: idToken!,
            referralCode: referralCode || undefined,
            nonce: nonce!,
          });
        saveUserJwt(response.accessToken);
        if (response.newUser) {
          const me = await accountStore.get(true);
          if (me) {
            posthogIdentify(me);
          }
          onSignup?.();
        } else {
          onLogin?.();
        }
      } catch (err) {
        console.error('Authentication error:', err);
        // separate one for future debug simplification
        const errorMessage = 'Failed to complete authentication';
        setError(errorMessage);
        setIsProcessing(false);
      }
    };

    handleCallback();
  }, [accountsService, onLogin, onSignup, accountStore]);

  return (
    <Rows spacing={24}>
      {isProcessing ? (
        <ProgressBar />
      ) : (
        <>
          <RedErrorText error={error || ''} />
          <Button
            label="Return to Login"
            onClick={() => {
              window.location.href = '/login';
            }}
            size="large"
          />
        </>
      )}
    </Rows>
  );
}

// dummy custom progress bar
// transparent + loads a little bit faster, no measured steps required, just placeholder for single transition
const ProgressBar = () => (
  <Rows spacing={16} xalign="center">
    <IconRelumeColorLarge />
    <div className={styles.progressBar}>
      <div className={styles.fill} />
    </div>
  </Rows>
);
